import React, { useState } from 'react';
import { IconButton, Box, Typography } from '@mui/material';
import { MdDeleteForever, MdEdit } from 'react-icons/md';

const LayoutCard = ({ layout, onEdit, onDelete, onOpenGallery }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [showGallery, setShowGallery] = useState(false);

    // Use products array from API response, falling back to empty array if not present
    const products = Array.isArray(layout.products) ? layout.products : [];
    const images = products
        .map((product) => product?.image)
        .filter(Boolean); // Filter out null/undefined images
    const displayedImages = images.slice(0, 4);
    const hasMoreImages = images.length > 4;

    const handleToggleGallery = () => {
        setShowGallery(!showGallery);
    };

    const getStatusStyles = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
                return { backgroundColor: '#0d863f', color: 'white' };
            case 'inactive':
                return { backgroundColor: '#f59e0b', color: 'white' };
            case 'archived':
                return { backgroundColor: '#6b7280', color: 'white' };
            default:
                return { backgroundColor: '#e5e7eb', color: '#374151' };
        }
    };

    const statusStyles = getStatusStyles(layout.status);

    const handleEditClick = (e) => {
        e.stopPropagation(); // Prevent card click (gallery open) when editing
        console.log('Edit clicked for layout:', layout._id);
        onEdit && onEdit(layout);
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation(); // Prevent card click (gallery open) when deleting
        console.log('Delete clicked for layout:', layout._id);
        onDelete && onDelete(layout);
    };

    return (
        <div style={{ position: 'relative', marginBottom: '16px' }}>
            {!showGallery && (
                <div
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '16px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
                        border: '1px solid #f1f5f9',
                        overflow: 'hidden',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        position: 'relative',
                        cursor: 'pointer',
                    }}
                    className="layout-card"
                    onClick={() => {
                        if (onOpenGallery) {
                            onOpenGallery(layout);
                            return;
                        }
                        handleToggleGallery();
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '24px',
                            // gap: '24px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    width: '300px',
                                    height: '100px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }}
                            >
                                {displayedImages.length > 0 ? (
                                    displayedImages.map((image, index) => {
                                        const offset = displayedImages
                                            .slice(0, index)
                                            .reduce((acc, _, i) => acc + (60 - i * 5), 0);
                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    position: 'absolute',
                                                    left: `${offset}px`,
                                                    width: `${80 - index * 5}px`,
                                                    height: `${80 - index * 5}px`,
                                                    zIndex: 5 - index,
                                                    transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                                                }}
                                                className="image-stack"
                                            >
                                                <img
                                                    src={image}
                                                    alt={`${layout.type} Image ${index + 1}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                        border: '3px solid #ffffff',
                                                        boxShadow: '0 3px 12px rgba(0,0,0,0.1)',
                                                        transition: 'transform 0.3s ease',
                                                    }}
                                                />
                                            </div>
                                        );
                                    })
                                ) : (
                                    <Typography variant="body2" color="#64748b">
                                        No images available
                                    </Typography>
                                )}
                                {hasMoreImages && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            left: `${displayedImages.reduce(
                                                (acc, _, i) => acc + (60 - i * 5),
                                                0
                                            )}px`,
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            background: 'linear-gradient(45deg, #ec4899, #3b82f6)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxShadow: '0 3px 12px rgba(0,0,0,0.1)',
                                            border: '2px solid #ffffff',
                                            zIndex: 6,
                                            transition: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                                        }}
                                        className="more-indicator"
                                    >
                                        <span
                                            style={{
                                                fontSize: '12px',
                                                fontWeight: 700,
                                                color: '#ffffff',
                                                textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                                            }}
                                        >
                                            +{images.length - 4}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: '16px',
                                flex: 1,
                                textAlign: 'center',
                            }}
                        >
                            <div>
                                <h3
                                    style={{
                                        fontFamily: 'mulish, sans-serif',
                                        fontWeight: 600,
                                        color: '#0f172a',
                                        fontSize: '1.1rem',
                                        lineHeight: 1.3,
                                        margin: 0,
                                        marginBottom: '4px',
                                    }}
                                >
                                    {layout.type}
                                </h3>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '40px' }}>
                                <span
                                    style={{
                                        ...statusStyles,
                                        fontWeight: 600,
                                        fontSize: '0.75rem',
                                        height: '24px',
                                        borderRadius: '12px',
                                        padding: '0 12px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        transition: 'all 0.2s ease',
                                    }}
                                >
                                    {layout.status}
                                </span>
                                <IconButton
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        fontWeight: 500,
                                        color: '#2563eb',
                                        backgroundColor: 'transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        border: 'none',
                                    }}
                                    className="edit-button"
                                    onClick={handleEditClick}
                                >
                                    <MdEdit style={{ color: '#2563eb', fontSize: '1.4rem' }} />
                                </IconButton>
                                <IconButton
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        fontWeight: 500,
                                        color: '#dc2626',
                                        backgroundColor: 'transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        border: 'none',
                                    }}
                                    className="delete-button"
                                    onClick={handleDeleteClick}
                                >
                                    <MdDeleteForever style={{ color: 'red', fontSize: '1.4rem' }} />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .layout-card:hover {
                    box-shadow: 0 20px 25px -5px rgba(0,0,0,0.12), 0 10px 10px -5px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px) !important;
                    border-color: #e2e8f0 !important;
                }
                
                .image-stack:hover {
                    transform: translateY(-4px) scale(1.05) !important;
                    zIndex: 10 !important;
                }
                
                .more-container:hover .more-glow {
                    opacity: 0.4 !important;
                }
                
                .edit-button:hover {
                    background-color: #eff6ff !important;
                    border-color: #3b82f6 !important;
                    transform: translateY(-1px) !important;
                    box-shadow: 0 4px 8px rgba(37,99,235,0.15) !important;
                }
                
                .delete-button:hover {
                    background-color: #fef2f2 !important;
                    border-color: #f87171 !important;
                    transform: translateY(-1px) !important;
                    box-shadow: 0 4px 8px rgba(220,38,38,0.15) !important;
                }
            `}</style>
        </div>
    );
};

export default LayoutCard;